
import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { Dialog, DialogTrigger } from '@/components/ui/dialog';
import BookingForm from './BookingForm';

const BookingHeader: React.FC = () => {
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <div>
        <h1 className="text-2xl font-bold">Booking av sponsede artikler</h1>
        <p className="text-muted-foreground mt-1">
          Administrer betalte artikler (BB - Betalt Brief)
        </p>
      </div>
      
      <Dialog>
        <DialogTrigger asChild>
          <Button>
            <Plus className="h-4 w-4" />
            <span>Ny booking</span>
          </Button>
        </DialogTrigger>
        <BookingForm />
      </Dialog>
    </div>
  );
};

export default BookingHeader;
